import React from "react";
import { Box } from "@mui/material";

type QuizSectionProps = {
  children: React.ReactNode;
};

/**
 * Transparent passthrough wrapper for a step's question(s). The cream canvas +
 * spacing now come from QuizShell, so this no longer draws its own card.
 */
export function QuizSection({ children }: QuizSectionProps) {
  return (
    <Box
      sx={{
        width: "100%",
        minWidth: 0,
        display: "flex",
        flexDirection: "column",
        // Generous gap so stacked per-dog question blocks read as separate sections
        gap: { xs: "44px", md: "56px" },
      }}
    >
      {children}
    </Box>
  );
}
